export default function Definition() {
    return (
        <section className="section-padding" id="definition">
            <span className="term">/ˈhabət/</span>
            <span className="description"> : the prevailing disposition or character of a person's thoughts and feelings</span>
        </section>
    );
}